import request from '@/services/interceptor.js'

// ── Endpoint cliente ──────────────────────────────────────────────────────────

/** Recupera i dati abbonamento del cliente loggato */
export const get_mio_abbonamento = () =>
    request({ url: '/abbonamento/me', method: 'get' })

/** Storico richieste del cliente */
export const get_mie_richieste = () =>
    request({ url: '/abbonamento/me/richieste', method: 'get' })

/**
 * Invia una richiesta di modifica piano.
 * @param {{ tipoRichiesta, pianoRichiesto, utentiExtraRichiesti, noteCliente }} data
 */
export const invia_richiesta = (data) =>
    request({ url: '/abbonamento/me/richieste', method: 'post', data })

/**
 * Calcola il pro-rata per un cambio piano (prima di inviare la richiesta).
 * @param {string} pianoNuovo - 'basic'|'pro'
 * @param {number} utentiExtra
 */
export const calcola_prorata_cliente = (pianoNuovo, utentiExtra = 0) =>
    request({
        url: '/abbonamento/me/prorata',
        method: 'get',
        params: { pianoNuovo, utentiExtra }
    })

// ── Endpoint admin ────────────────────────────────────────────────────────────

/** Lista aziende con info abbonamento (pannello GestioneAziende) */
export const get_aziende_con_abbonamento = () =>
    request({ url: '/abbonamento/admin/aziende', method: 'get' })

/** Badge: numero richieste pendenti in totale */
export const get_richieste_pendenti_count = () =>
    request({ url: '/abbonamento/admin/richieste-pendenti-count', method: 'get' })

/** Dettaglio abbonamento + richieste di una specifica azienda */
export const get_dettaglio_azienda = (aziendaId) =>
    request({ url: `/abbonamento/admin/aziende/${aziendaId}`, method: 'get' })

/**
 * Crea abbonamento ex-novo.
 * @param {number} aziendaId
 * @param {{ tipoLicenza, utentiExtra, dataInizio, dataScadenza, stato, note }} data
 */
export const crea_abbonamento = (aziendaId, data) =>
    request({ url: `/abbonamento/admin/aziende/${aziendaId}`, method: 'post', data })

/**
 * Modifica diretta abbonamento (operatore).
 * @param {number} aziendaId
 * @param {{ tipoLicenza, utentiExtra, dataInizio, dataScadenza, stato, note }} data
 */
export const modifica_abbonamento = (aziendaId, data) =>
    request({ url: `/abbonamento/admin/aziende/${aziendaId}`, method: 'put', data })

/**
 * Calcola pro-rata lato admin prima dell'approvazione.
 * @param {number} aziendaId
 * @param {string} pianoNuovo
 * @param {number} utentiExtra
 */
export const calcola_prorata_admin = (aziendaId, pianoNuovo, utentiExtra = 0) =>
    request({
        url: `/abbonamento/admin/prorata/${aziendaId}`,
        method: 'get',
        params: { pianoNuovo, utentiExtra }
    })

/**
 * Approva o rifiuta una richiesta pendente.
 * @param {number} richiestaId
 * @param {{ stato: 'approvata'|'rifiutata', noteOperatore: string }} data
 */
export const evadi_richiesta = (richiestaId, data) =>
    request({ url: `/abbonamento/admin/richieste/${richiestaId}`, method: 'put', data })